import { useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Col, Row } from 'reactstrap';
import forms from 'constants/forms';
import common from 'constants/common';
import Pagination from 'components/molecules/pagination';
import AutoCompletePatient from 'components/molecules/autocompleteFilter/patient';
import AutoCompleteClinics from 'components/molecules/autocompleteFilter/adminPanelClinic';

const DEFAULT_PATIENT_FILTER = forms.adminPanelPatientFilter[0];
const DEFAULT_CLINIC_FILTER = forms.clinicFilterOptions[0];
const Toolbar = ({
  setPage,
  setFilters,
  page,
  filters,
  count,
  loading,
  perPage,
  itemsLength,
  statusOptions,
  ccmStatusOptions,
}) => {
  const [filter, setFilter] = useState(DEFAULT_PATIENT_FILTER);
  const statusValue = (statusName) => {
    const value = statusOptions.find((element) => element.value === statusName);
    return value;
  };
  const ccmStatusValue = (statusName) => {
    const value = ccmStatusOptions.find(
      (element) => element.value === statusName,
    );
    return value;
  };
  const clinicsFilter = DEFAULT_CLINIC_FILTER;
  const selectTheme = (theme) => ({
    ...theme,
    borderRadius: 12,
    colors: {
      ...theme.colors,
      ...common.primaryColors,
    },
  });

  return (
    <Row>
      <Col sm={3} md={2}>
        <strong>RPM Status</strong>
        <Select
          options={statusOptions}
          defaultValue={statusValue(filters.status)}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          value={statusValue(filters.status)}
          onChange={({ value }) => setFilters({ ...filters, status: value })}
        />
      </Col>
      <Col sm={3} md={2}>
        <strong>CCM Status</strong>
        <Select
          options={ccmStatusOptions}
          defaultValue={ccmStatusOptions[0]}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          value={ccmStatusValue(filters.ccmStatus)}
          onChange={({ value }) => setFilters({ ...filters, ccmStatus: value })}
        />
      </Col>
      <Col sm={3} md={2}>
        <strong>Clinic</strong>
        <AutoCompleteClinics
          filter={clinicsFilter}
          handleClick={({ value }) => {
            setFilters({ ...filters, clinicGuid: value });
          }}
        />
      </Col>
      <Col sm={3} md={2}>
        <strong>Patient List Options</strong>
        <Select
          options={forms.adminPanelPatientFilter}
          defaultValue={filter}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          value={filter}
          onChange={(value) => setFilter(value)}
        />
      </Col>
      <Col sm={3} md={2}>
        <strong>Patient Filter</strong>
        <AutoCompletePatient
          status={filters.status}
          clinicGuid={filters.clinicGuid}
          filter={filter}
          getInactiveClinicData
          handleClick={({ value }) => {
            setFilters({ ...filters, patientGuid: value });
          }}
        />
      </Col>
      <Col sm={3} md={2}>
        <Pagination
          title=""
          page={page}
          pageTotal={itemsLength}
          itemsPerPage={perPage}
          total={count}
          handleFirstClick={() => setPage(1)}
          handleLastClick={() => setPage(Math.ceil(count / perPage))}
          handlePrevClick={() => setPage(page - 1)}
          handleNextClick={() => setPage(page + 1)}
          loading={loading}
        />
      </Col>
    </Row>
  );
};

Toolbar.propTypes = {
  setPage: PropTypes.func.isRequired,
  setFilters: PropTypes.func.isRequired,
  page: PropTypes.number,
  filters: PropTypes.shape({
    status: PropTypes.string,
    ccmStatus: PropTypes.string,
    clinicGuid: PropTypes.string,
    patientGuid: PropTypes.string,
  }),
  perPage: PropTypes.number,
  loading: PropTypes.bool,
  count: PropTypes.number,
  itemsLength: PropTypes.number,
  statusOptions: PropTypes.arrayOf(PropTypes.shape({})),
  ccmStatusOptions: PropTypes.arrayOf(PropTypes.shape({})),
};

export default Toolbar;
